module.exports = __webpack_public_path__ + "static/media/imgop_renewable_heat.dc0f2eb1.jp2";